var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-product",
      class: { edit: _vm.isSelected },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c("p", { staticClass: "text-finish", on: { click: _vm.finish } }, [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.done"))),
      ]),
      _c(
        "div",
        {
          class: [
            "sticker",
            "sticker-product",
            `style${_vm.stickerInstance.data.styleVariant}`,
          ],
          on: { click: _vm.stickerInstance.nextStyleVariant },
        },
        [
          _c("div", {
            staticClass: "icon",
            style: { backgroundColor: _vm.stickerInstance.data.color },
          }),
          _c(
            "p",
            {
              class: `${_vm.stickerInstance.data.font}`,
              style: { color: _vm.stickerInstance.data.color },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.stickerInstance.data.products.length == 1
                      ? _vm.stickerInstance.data.products[0].text
                      : `${_vm.stickerInstance.data.products.length} produits`
                  ) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "options" }, [
        _c("div", { staticClass: "list-option-text hide-scrollbar" }, [
          _c(
            "div",
            { staticClass: "texts" },
            _vm._l(
              [
                "modern",
                "classic",
                "signature",
                "editor",
                "poster",
                "bubble",
                "deco",
                "squeeze",
                "typewriter",
                "strong",
                "meme",
                "elegant",
                "directional",
                "literature",
              ],
              function (font) {
                return _c(
                  "div",
                  {
                    class: [
                      "text",
                      `${font}-font`,
                      font,
                      {
                        active: _vm.stickerInstance.data.font == `${font}-font`,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        _vm.stickerInstance.data.font = `${font}-font`
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(font) +
                        "    \n                "
                    ),
                  ]
                )
              }
            ),
            0
          ),
        ]),
        _c("div", { staticClass: "list-option-color" }, [
          _c("div", { staticClass: "pipette" }, [
            _c(
              "div",
              {
                staticClass: "icon",
                style: { backgroundColor: _vm.pickerColors.hex },
                on: {
                  click: () => {
                    _vm.stickerInstance.data.color = _vm.pickerColors.hex
                    _vm.colorPickerShow = true
                    _vm.showPipette = true
                  },
                },
              },
              [
                _vm.colorPickerShow
                  ? _c(
                      "div",
                      {
                        staticClass: "picker-color",
                        on: {
                          mouseleave: function ($event) {
                            _vm.colorPickerShow = false
                          },
                          mousedown: function ($event) {
                            _vm.showPipette = false
                          },
                        },
                      },
                      [
                        _vm.eyeDropperIsAccess && _vm.showPipette
                          ? _c("div", {
                              staticClass: "icon-pipette",
                              on: {
                                mousedown: function ($event) {
                                  $event.stopPropagation()
                                },
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.startEyeDropper.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _c("chrome-picker", {
                          attrs: { value: _vm.pickerColors },
                          on: { input: _vm.updateFromPicker },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "color-carousel" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    perPage: 1,
                    adjustableHeight: true,
                    centerMode: true,
                  },
                  on: { pageChange: () => {} },
                },
                _vm._l(
                  [
                    [
                      "#FFFFFF",
                      "#000000",
                      "#4397EF",
                      "#70C04F",
                      "#F6CB5B",
                      "#F08C34",
                      "#EA4857",
                      "#D12D69",
                      "#B100C0",
                    ],
                    [
                      "#EA3323",
                      "#ED858E",
                      "#F7D0D1",
                      "#FADAB4",
                      "#F5C281",
                      "#D18E47",
                      "#99643A",
                      "#432324",
                      "#1D4A29",
                    ],
                    [
                      "#262626",
                      "#363636",
                      "#555555",
                      "#737373",
                      "#999999",
                      "#B2B2B2",
                      "#C7C7C7",
                      "#DBDBDB",
                      "#EFEFEF",
                    ],
                  ],
                  function (colors, index) {
                    return _c(
                      "Slide",
                      { key: index },
                      _vm._l(colors, function (colorHexa) {
                        return _c("div", {
                          staticClass: "color",
                          style: `background-color:${colorHexa}`,
                          on: {
                            click: () => {
                              _vm.stickerInstance.data.color = colorHexa
                              _vm.pickerColors.hex = colorHexa
                            },
                          },
                        })
                      }),
                      0
                    )
                  }
                ),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }